<template>
  <avs-card>
    <template v-slot:title>
      <v-card-title class="pa-0">{{ title }}</v-card-title>
    </template>
    <template v-slot:content>
      <v-container>
        <v-card-text>
          <v-form
            ref="form"
            v-model="isFormValid"
            lazy-validation
          >
            <v-row>
              <template v-for="(item, index) in invites">
                <v-col
                  cols="12"
                  md="3"
                  :key="index"
                >
                  <v-text-field
                    v-model="item.email"
                    :rules="rules.email"
                    required
                    clearable
                    :label="$t('views.team.email')"
                    :error-messages="item.errors"
                    autofocus
                    @keydown.native="item.errors = ''"
                    placeholder="name@example.com"
                  ></v-text-field>
                </v-col>

                <v-col
                  cols="6"
                  md="3"
                  v-for="privilege in privileges"
                  :key="privilege.name + index + privilege.id"
                  class="d-flex justify-center justify-md-end"
                >
                  <v-checkbox
                    v-model="item.privileges[privilege.name]"
                    :label="privilege.text"
                    color="primary"
                    @click.native="selectRole(index, privilege.name)"
                  ></v-checkbox>
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                  :key="'delete' + index"
                  class="d-flex align-center justify-center justify-md-end"
                >
                  <avs-button
                    class="mr-4"
                    fab
                    iconI="mdi-plus"
                    icon
                    label
                    small
                    :spantext="$t('actions.add', { entity: $t('commons.member').toLowerCase() })"
                    color="secondary"
                    @click.stop="addInvite"
                  />

                  <avs-button
                    fab
                    iconI="mdi-delete"
                    icon
                    label
                    small
                    text
                    :spantext="$t('actions.delete', { entity: $t('commons.member').toLowerCase() })"
                    color="error"
                    @click.stop="deleteInvite(index)"
                  />
                </v-col>
              </template>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-end">
          <avs-button
            large
            color="blue white--text"
            noSpantext
            @click.stop="sendInvite"
          >
            <template v-slot:name>
              {{ $t("views.team.send_invites") }}
            </template>
          </avs-button>
        </v-card-actions>
      </v-container>
    </template>
  </avs-card>
</template>

<script>
import { required, email } from "@/utils/validator"
import { mkInvites } from "@/utils/datamodels"
export default {
  name: "TeamInvitation",
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      privileges: [
        { text: this.$t("commons.inspector"), all: false, name: "inspector" },
        { text: this.$t("commons.operator"), all: false, name: "operator" }
      ],
      isFormValid: false,
      invites: [],
      rules: {
        email: [required, email]
      }
    }
  },
  created() {
    this.invites.push({ ...mkInvites() })
  },
  computed: {
    companyId() {
      return this.$store.state.app.company.pk
    }
  },
  methods: {
    selectRole(id, role) {
      for (const key of Object.keys(this.invites[id].privileges)) {
        this.invites[id].privileges[key] = false
      }
      this.invites[id].privileges[role] = true
    },
    addInvite() {
      this.invites.push({ ...mkInvites() })
    },
    deleteInvite(index) {
      if (this.invites.length > 1) this.invites.splice(index, 1)
    },
    sendInvite() {
      if (this.invites.length > 0) {
        const form = this.$refs.form
        this.isFormValid = form.validate()
        if (this.isFormValid) {
          this.$emit("send-invites", this.invites)
          form.resetValidation()
          this.invites = [{ ...mkInvites() }]
        }
      }
    }
  }
}
</script>
